(function($) {

	'use strict';

	var init = function() {
        resizeVideo();
        manageAgendaScroll();
	};

	var resizeVideo = function(){

		$(window).resize(function() {
            var videoWidth = $('.videoContainer iframe').outerWidth();
            $('.videoContainer iframe').height((videoWidth /16) * 9);
        }).resize();

	};

	var manageAgendaScroll = function(){
        
        $(".agenda__body__wrapper").mCustomScrollbar({
            theme:"light",
			scrollInertia:500,
			alwaysShowScrollbar: 2,
        });
        
    };


	$(document).ready(function() {
		init();
	});

})(jQuery);
